import { render } from "./CertProgressIndicator.vue?vue&type=template&id=36fbff40"
const script = {}

import exportComponent from "C:\\projects\\cert-v3\\cert\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__